<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <g
      stroke-linejoin="round"
      fill="none"
    >
      <path d="M17.15 21.5a1.6 1.6 0 01-.68-.15.88.88 0 01-.11-.06L12 18.81l-4.36 2.48a1.23 1.23 0 01-.11.06 1.61 1.61 0 01-1.61-.15 1.6 1.6 0 01-.62-1.6l1.01-4.92-1.7-1.55-2-1.82a.8.8 0 01-.08-.09 1.58 1.58 0 01.87-2.65.92.92 0 01.1-.02L8.5 8l2.06-4.57a.73.73 0 01.07-.11 1.59 1.59 0 012.77 0l.06.12L15.52 8l4.98.56a.85.85 0 01.1.01 1.59 1.59 0 01.88 2.66l-.09.08-3.7 3.38 1.01 4.9a1.6 1.6 0 01-.62 1.61 1.58 1.58 0 01-.93.3z" />
      <path
        d="M16.99 19.7l-.96-4.67a1.7 1.7 0 01.52-1.6l3.52-3.21-4.74-.53a1.7 1.7 0 01-1.36-.99l-1.96-4.35-1.97 4.35a1.7 1.7 0 01-1.36.99l-4.74.52 3.53 3.21c.44.4.64 1.01.52 1.6l-.96 4.67 4.13-2.36a1.7 1.7 0 011.69 0l4.14 2.36m.16 1.81a1.6 1.6 0 01-.8-.2l-4.34-2.5-4.35 2.5-.12.05c-.51.24-1.15.18-1.6-.15a1.6 1.6 0 01-.63-1.6l1.01-4.92c-.4-.36-1.01-.93-1.7-1.54l-2-1.83a1.6 1.6 0 01-.44-1.67A1.6 1.6 0 013.5 8.55L8.5 8l2.07-4.57a1.59 1.59 0 012.9 0L15.52 8l4.98.56.11.01a1.6 1.6 0 01.78 2.74l-3.7 3.37 1.01 4.91a1.58 1.58 0 01-1.55 1.9z"
        fill="currentColor"
      />
    </g>
  </g>
</template>
